// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.center-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  z-index: 8;
}

.center-modal-main {
  background: #FFFFFF;
  padding: 15px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  justify-self: center;
  border-radius: 8px;
  min-height: 33vh;
  margin: auto;
  margin-top: 15vh;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.close-button {
  position: absolute;
  top: 16px; /* Уменьшите значение, чтобы кнопка была ближе к краю */
  right: 16px; /* Уменьшите значение, чтобы кнопка была ближе к краю */
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: black; /* Черный цвет для крестика */
}

.display-block {
  display: flex;
}

.display-none {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/CenterModal/CenterModal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAEF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EAEA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA,EAAA,uDAAA;EACA,WAAA,EAAA,uDAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA,EAAA,6BAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;AAAF","sourcesContent":[".center-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  justify-content: center;\n  z-index: 8;\n}\n\n\n.center-modal-main {\n  background: #FFFFFF;\n  padding: 15px;\n  box-sizing: border-box;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  justify-self: center;\n  border-radius: 8px;\n  min-height: 33vh;\n  margin: auto;\n  margin-top: 15vh;\n  max-width: 500px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n  z-index: 10;\n}\n\n.close-button {\n  position: absolute;\n  top: 16px; /* Уменьшите значение, чтобы кнопка была ближе к краю */\n  right: 16px; /* Уменьшите значение, чтобы кнопка была ближе к краю */\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: black; /* Черный цвет для крестика */\n}\n\n.display-block {\n  display: flex;\n}\n\n.display-none {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"center-modal": `center-modal`,
	"center-modal-main": `center-modal-main`,
	"close-button": `close-button`,
	"display-block": `display-block`,
	"display-none": `display-none`
};
export default ___CSS_LOADER_EXPORT___;
